import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { achProcessorService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useSubmitMerchantAchProcessorMutation = merchantId => {
	const dispatch = useDispatch();

	return useMutation(
		(values: { [key: string]: any }) => {
			dispatch(uiActions.showSpinnerOverlay());

			return achProcessorService.submitMerchantAchProcessor(
				merchantId,
				values,
			);
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "ACH Processor saved successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSubmitMerchantAchProcessorMutation;
